import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { TagsInput } from "react-tag-input-component";
import { colors } from "../../common/colors";
import { setErrors, setItem } from "../../redux/Reducers/createPostReducer";
import { useAppDispatch } from "../../redux/store";
import Section from "./Section";
import { T } from "react-translator-component";

export default function Tags() {
  const dispatch = useAppDispatch();

  const tagObjects = useSelector((state: any) => state.createPost.values.tags);
  const errors = useSelector((state: any) => state.createPost.errors);

  const handleChangeTags = (values: string[]) => {
    const tagList = tagObjects.reduce((acc: any[], tagObj: any) => {
      return !tagObj?._destroy ? [ ...acc, tagObj.tag] : acc
    }, []);

    const newTag = values.find((value: string) => !tagList.includes(value));
    if (!newTag) return
    dispatch(setItem({key: 'tags', value: [...tagObjects, {tag: newTag}]}));
  }

  const handleDeleteTag = (deleteTag: string) => {
    const _tagObjList = tagObjects
      .filter((tagObj: any) => !(tagObj.tag === deleteTag && !tagObj.id))
      .map((tagObj: any) =>
        tagObj.tag === deleteTag ? { ...tagObj, _destroy: "1" } : tagObj
      )

    dispatch(setItem({key: 'tags', value: _tagObjList}));
  };

  const validateTags = (newTag: string) => {
    const filteredTag = tagObjects.filter((tag: any) => tag._destroy !== "1")
    if (filteredTag.some((tag: any) => tag.tag === newTag)) {
      dispatch(setErrors({tags: T("error_post_tag")}))
    }
  }

  return (
    <Section
      title={T("post_tag")}
      body={
        <>
          <TagsInput
            value={tagObjects.filter((tag: any) => tag._destroy !== "1").map((tag: any) => tag.tag)}
            onChange={(newValue) => handleChangeTags(newValue)}
            onExisting={(inputedValue)=>{validateTags(inputedValue)}}
            onRemoved={handleDeleteTag}
            name="GroupTags"
            separators={[" ", ",", "Enter", "return"]}
          />
          {errors.tags && (
            <Typography sx={ styles.tagError}>
              {errors.tags}
            </Typography>
          )}
        </>
      }
    />
  )
}

const styles = {
  tagError: {
    color: colors.farm_red600,
    marginLeft: "14px",
    marginTop:"4px",
    fontSize: "0.75rem"
  },
}
